import { render, staticRenderFns } from "./Webrtc.vue?vue&type=template&id=2627dbd9&scoped=true&"
import script from "./Webrtc.vue?vue&type=script&lang=js&"
export * from "./Webrtc.vue?vue&type=script&lang=js&"
import style0 from "./Webrtc.vue?vue&type=style&index=0&id=2627dbd9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2627dbd9",
  null
  
)

export default component.exports